var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"latest-update-time"},[_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":require("@/assets/dashboard/时间.png")}}),_c('span',{staticClass:"text"},[_vm._v("最近更新时间："+_vm._s(_vm.date.toLocaleDateString()))])])])}
var staticRenderFns = []

export { render, staticRenderFns }